import { GetterTree } from 'vuex';

const instanceOfUserSocialNetwork = (
  object: Store.LiveSocial.UserSocialNetwork | Store.LiveSocial.LiveSocialNetwork,
): object is Store.LiveSocial.UserSocialNetwork => (
  'lives' in object
);

const liveSocialGetters: GetterTree<Store.LiveSocial.State, RootState> = {
  createdServices(state): Store.LiveSocial.LiveSocialNetwork[] {
    return Object.values(state.providers)
      .flat()
      .map((account: Store.LiveSocial.UserSocialNetwork | Store.LiveSocial.LiveSocialNetwork) => (
        instanceOfUserSocialNetwork(account) ? (account.lives || []) : account
      ))
      .flat();
  },
  isThereAtLeastOneBroadcastingWay(state): boolean {
    return !!Object.values(state.providers).flat().length;
  },
};

export default liveSocialGetters;
